import { combineReducers } from '@reduxjs/toolkit';
import { dictionariesReducer } from './data/dictionaries/reducer';

export const dataReducer = combineReducers({
	dictionaries: dictionariesReducer,
});
